// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__I51p-","error__info":"NotFound_error__info__sLz+b","error__icon":"NotFound_error__icon__+b4tk"};